import React from "react";

import styled from "styled-components";

import ManuscriptFilePanel from "components/organisms/manuscript/file/ManuscriptFilePanel";
import ManuscriptSearchPanel from "components/organisms/manuscript/search/ManuscriptSearchPanel";

const Panel = styled.section`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    min-height: 0;
    height: 100%;
    overflow: hidden;
    background: var(--color-White);
`;

const Shell = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 0;
    min-height: 0;
    width: 100%;
    height: 100%;
`;

function ManuscriptLeftPanel({
    activePanel,
    roots,
    expandedFolderIds,
    selectedNodeId,
    treeActionMenuNodeId,
    treeActionMenuRef,
    createNode,
    fileInputRef,
    uploadBinary,
    onOpenNode,
    onMoveNodeToParent,
    onTreeActionMenuOpen,
    searchQuery,
    setSearchQuery,
    onSearchSubmit,
    searchLoading,
    searchResults,
    onSearchResultSelect,
    outlineItems,
    outlineEnabled,
    activeOutlineLine,
    activeOutlineIds,
    onOutlineSelect,
}) {
    return (
        <Panel>
            <Shell>
                {activePanel === "files" ? (
                    <ManuscriptFilePanel
                        roots={roots}
                        expandedFolderIds={expandedFolderIds}
                        selectedNodeId={selectedNodeId}
                        treeActionMenuNodeId={treeActionMenuNodeId}
                        treeActionMenuRef={treeActionMenuRef}
                        createNode={createNode}
                        fileInputRef={fileInputRef}
                        uploadBinary={uploadBinary}
                        onOpenNode={onOpenNode}
                        onMoveNodeToParent={onMoveNodeToParent}
                        onTreeActionMenuOpen={onTreeActionMenuOpen}
                        outlineItems={outlineItems}
                        outlineEnabled={outlineEnabled}
                        activeOutlineLine={activeOutlineLine}
                        activeOutlineIds={activeOutlineIds}
                        onOutlineSelect={onOutlineSelect}
                    />
                ) : null}

                {activePanel === "search" ? (
                    <ManuscriptSearchPanel
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        onSearchSubmit={onSearchSubmit}
                        searchLoading={searchLoading}
                        searchResults={searchResults}
                        onSearchResultSelect={onSearchResultSelect}
                    />
                ) : null}
            </Shell>
        </Panel>
    );
}

export default ManuscriptLeftPanel;
